<template>
	<base-crud-page-create
		v-if="can('DEPARTMENT_CREATE')"
		:title="$tc('menu.department', 1)"
		:back-url="{ name: 'mainDepartments' }"
	>
		<template #form>
			<the-form :model="model" @emit:submit="save"/>

		</template>
	</base-crud-page-create>
</template>

<script>
import BaseCrudPageCreate from '../../../../components/BaseCrudPageCreate';
import FormService from '../../../../services/FormService';
import TheForm from '../components/TheForm';


export default {
	name: 'OrganizationsCreate',
	components: {
		TheForm,
		BaseCrudPageCreate,
	},
	data() {
		return {
			model: new FormService({
				name: '',
				officeId: '',
				chiefId: ''
			}),
		};
	},
	methods: {
		save() {
			this.$api
				.post('department', this.model.GetData())
				.then(response => {
					this.$router.push({name: 'mainDepartments'});
				});
		}
	}
};
</script>